import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PdfViewer from 'pdf/PdfViewer';
import HtmlViewer from 'pdf/HtmlViewer';
import {purchaseDocumentFetch, PURCHASE_DOCUMENT_FETCH} from './redux';
import {actionPending, actionFail} from 'utils/redux/thunkActionHelpers';
import LoadingBlocking from 'components/loading/LoadingBlocking';
import DocumentFailure from '../pdf/DocumentFailure';

@connect(
  (state, ownProps) => {
    return {
      externalId: ownProps.params.externalId,
      notification: ownProps.location.query.notification,
      documentType: ownProps.location.query.documentType,
      document: state.purchases.document,
      actionType: state.purchases.document.type,
      actionStatus: state.purchases.document.status
    };
  },
  dispatch => (bindActionCreators({purchaseDocumentFetch}, dispatch))
)
export default class DocumentController extends React.Component {

  static propTypes = {
    externalId: PropTypes.string.isRequired,
    notification: PropTypes.string.isRequired,
    documentType: PropTypes.string.isRequired,
    document: PropTypes.object,
    actionType: PropTypes.string,
    actionStatus: PropTypes.string,
    purchaseDocumentFetch: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.purchaseDocumentFetch(this.props.externalId, this.props.notification, this.props.documentType);
  }

  render() {
    if (!this.props.actionStatus || actionPending(PURCHASE_DOCUMENT_FETCH, this.props.actionType, this.props.actionStatus)) {
      return (<LoadingBlocking />);
    }

    if (actionFail(PURCHASE_DOCUMENT_FETCH, this.props.actionType, this.props.actionStatus)) {
      return <DocumentFailure />;
    }

    if (this.props.document.mimeType === 'text/html') {
      return (
        <HtmlViewer content={this.props.document.content} />
      );
    }

    return (
      <PdfViewer pdfData={this.props.document.content} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/purchases/PurchaseDocumentController.js